export default function Logo({ className = "w-9 h-9" }) {
  return (
    <svg
      viewBox="0 0 886.93 884.48"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Green Gate logo"
      data-testid="gg-logo"
    >
      <g transform="translate(-0.635729,885.000000) scale(0.100000,-0.100000)"
fill="currentColor" stroke="none">
<path d="M3895 8843 c-375 -49 -758 -147 -1094 -279 -165 -66 -493 -228 -651
-324 -1013 -613 -1738 -1597 -2020 -2745 -86 -351 -123 -660 -124 -1050 -1
-447 52 -832 168 -1238 466 -1620 1817 -2841 3476 -3141 286 -52 400 -61 790
-61 382 0 490 8 770 56 1076 186 2058 777 2737 1647 502 642 811 1403 910
2240 19 160 26 763 10 875 l-8 57 -1351 0 c-1108 0 -1349 -2 -1345 -13 11 -28
37 -177 47 -262 26 -236 -3 -499 -81 -740 -42 -126 -156 -352 -236 -465 -97
-136 -311 -347 -446 -439 -239 -161 -481 -255 -767 -297 -155 -22 -419 -15
-574 16 -632 126 -1147 579 -1350 1190 -69 207 -80 286 -80 555 0 268 10 339
79 553 172 527 604 960 1135 1136 l105 35 3 456 c3 523 17 466 -110 440 -209
-44 -439 -125 -636 -223 -782 -392 -1314 -1125 -1448 -1992 -22 -143 -30 -506
-14 -656 63 -622 325 -1179 760 -1615 227 -228 428 -373 715 -514 255 -126
513 -206 812 -252 158 -24 577 -24 733 0 612 95 1113 348 1532 773 359 366
598 804 704 1297 l28 127 443 0 443 0 -5 -27 c-3 -16 -12 -71 -21 -123 -24
-149 -79 -365 -133 -529 -234 -698 -696 -1323 -1302 -1758 -961 -689 -2211
-849 -3319 -426 -485 185 -896 457 -1271 839 -171 175 -285 316 -413 509 -317
477 -492 949 -572 1540 -23 165 -26 634 -6 800 77 625 286 1175 639 1672 480
677 1197 1171 2001 1379 110 28 397 84 433 84 5 0 9 176 9 450 l0 450 -37 -1
c-21 -1 -51 -4 -68 -6z"/>
</g>
    </svg>
  );
}
